export function categoryNavPageState(state = false, action) {
  switch (action.type) {
    case 'CATEGORY_NAV_PAGE':
      return action.url;
    default:
      return state;
  }
}

export function categoryNavState(state = false, action) {
  switch (action.type) {
    case 'CATEGORY_NAV':
      return action.navigation;
    default:
      return state;
  }
}

export function categoryNavSubRoute(state = false, action) {
  switch (action.type) {
    case 'CATEGORY_SUBROUTE':
      return action.slug;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/r_cateogory_nav.js